<template>
  <div id="package-creation-pricing">
    <binary
      option1="Unit Rate"
      option2="Flat Rate"
      Heading="Price Type"
      :selected="selected"
      @toggle="changePriceType"
    />
    <Input
      v-if="selected === 'Flat Rate'"
      class="scs-input"
      heading="Flat Rate"
      placeholder="400"
      type="number"
      :initialValue="flatRate"
      @scs-input="flatRateInput"
    />
    <Input
      v-if="selected === 'Unit Rate'"
      class="scs-input"
      heading="Minimum Quantity"
      placeholder="20"
      type="number"
      :initialValue="minUnits"
      @scs-input="minUnitsInput"
    />
    <Input
      v-if="selected === 'Unit Rate'"
      class="scs-input"
      heading="Price Per Unit"
      placeholder="40"
      type="number"
      :initialValue="unitRate"
      @scs-input="unitRateInput"
    />
  </div>
</template>
<script>
import Binary from "@/Components/Elements/Binary.vue";
import Input from "@/Components/Elements/Input.vue";
export default {
  data() {
    return {
      selected: "Unit Rate",
      minUnits: undefined,
      unitRate: undefined,
      flatRate: undefined,
      priceOption: undefined,
    };
  },
  computed: {},
  methods: {
    minUnitsInput(int) {
      this.minUnits = int;
      this.emitPricePackage();
    },
    unitRateInput(int) {
      this.unitRate = int;
      this.emitPricePackage();
    },
    flatRateInput(int) {
      this.flatRate = int;
      this.emitPricePackage();
    },
    changePriceType() {
      if (this.selected === "Unit Rate") {
        this.selected = "Flat Rate";
      } else {
        this.selected = "Unit Rate";
      }
      this.emitPricePackage();
    },
    emitPricePackage() {
      switch (this.selected) {
        case "Unit Rate":
          if (this.minUnits && this.unitRate) {
            let addOnPricing = {
              pricing: {
                minUnits: this.minUnits,
                unitRate: this.unitRate * 100,
              },
              priceOption: "Unit",
            };
            this.$emit("pricing-input", addOnPricing);
          }
          break;
        case "Flat Rate":
          if (this.flatRate) {
            let addOnPricing = {
              pricing: {
                flatRate: this.flatRate * 100,
              },
              priceOption: "Flat",
            };
            this.$emit("pricing-input", addOnPricing);
          }
          break;
      }
    },
  },
  created() {
    let { minUnits, flatRate, unitRate } = this.subject.pricing;
    let { priceOption } = this.subject;
    this.minUnits = minUnits;
    this.flatRate = flatRate;
    this.unitRate = unitRate;
    if (priceOption === "Unit") {
      this.selected = "Unit Rate";
    } else {
      this.selected = "Flat Rate";
    }
  },
  components: { Binary, Input },
  props: ["subject"],
  emits: ["pricing-input"],
};
</script>
<style scoped>
@media screen {
  #package-creation-pricing {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 50px 50px;
  }

  .scs-input {
    width: 250px;
  }
  @media (min-width: 800px) {
    #package-creation-pricing {
      min-height: 300px;
    }
  }
}
</style>
